import Logger from "@next/core-logger"

declare global {
    interface Window {
        dataLayer: any[]
    }
}

const checkPageSizeLimit = (pageSizeLimit: number) => {
    if (!performance) return
    if (!performance.getEntries()) return
    ;(performance as any).getEntries().forEach(entry => {
        if (entry.name === window.location.href && entry.decodedBodySize) {
            const pageSizeInKb = Math.round(entry.decodedBodySize / 1024)
            console.debug("page-size-plp", pageSizeInKb)
            if (pageSizeInKb > pageSizeLimit) {
                Logger.debug(pageSizeInKb, "page-size-plp-composition")
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({"data-page-size-above-900KB-desktop": "true"})
                window.dataLayer.push({"data-page-size": pageSizeInKb})
            }
        }
    })
}

export default checkPageSizeLimit
